export const LOADING_KEYS = {
  ASSESSMENT_NOTE: "assessmentNote",
  INDIVIDUAL_PATIENT: "individualPatient",
  TREATMENT_KEY: "treatmentKey",
  WOUND_EVENTS_ACTIVITY_LOG: "woundEvent",
  ADT_EVENTS_ACTIVITY_LOG: "adtEvents",
  VIEW_EVENTS_ACTIVITY_LOG: "viewEvent",
  DELETE_ASSESSMENT_NOTE: "deleteAssessmentNote",
  INTERVENTION_TREATMENT: "interventionTreatment",
  HEALING_TRAJECTORY: "healingTrajectory",
  // Report
  QUALITY_ASSURANCE_REPORT: "qualityAssuranceReport",
  QUALITY_ASSURANCE__CSV_REPORT: "qualityAssuranceCsvReport",
  TREATMENT_REPORT: "treatmentReport",
  TREATMENT_CSV_REPORT: "treatmentCsvReport"

};
